import { Flex, Stack } from '@chakra-ui/react';
import { Badge } from '@main/complykit/components/badge';
import { Heading } from '@main/complykit/components/heading';
import { Skeleton } from '@main/complykit/components/skeleton';
import { Text } from '@main/complykit/components/text';
import { useTranslation } from 'react-i18next';

import { DrawerProperty } from '../drawer/drawer-property';

/* The drawer's own geometry for an entity it does not know yet; the hidden
 * placeholder strings exist for their widths, varied so the column reads as data. */
const ROWS: ReadonlyArray<[label: string, value: string]> = [
  ['Status', 'A value that runs across most of the row'],
  ['Owner', 'A shorter value'],
  ['Category', 'A value of middling length here'],
  ['Created', 'A value about this long'],
  ['Updated', 'A short one'],
  ['Reference', 'A short one'],
  ['Linked to', 'A value that runs a little longer than most'],
];

export const DrawerSkeleton = () => {
  const { t } = useTranslation('ui');
  return (
    <Skeleton.Region label={t('loading.drawer')}>
      <Stack spacing={4} h="full" flexGrow={1} py={6} px={9}>
        <Stack direction="row" spacing={2}>
          <Skeleton isLoading>
            <Badge>Category</Badge>
          </Skeleton>
          <Skeleton isLoading>
            <Badge>Owner</Badge>
          </Skeleton>
        </Stack>
        <Skeleton isLoading>
          <Heading size="lg">The title of the record, about this long</Heading>
        </Skeleton>
        <Stack spacing={2} pt={6}>
          {ROWS.map(([label, value]) => (
            <DrawerProperty key={label}>
              <Flex flex={['', '', '0 0 135px']} py={2.5}>
                <Skeleton isLoading>
                  <Text size="sm" weight="medium">
                    {label}
                  </Text>
                </Skeleton>
              </Flex>
              <Flex flexGrow={1} py={2.5}>
                <Skeleton isLoading>
                  <Text size="sm">{value}</Text>
                </Skeleton>
              </Flex>
            </DrawerProperty>
          ))}
          <Stack spacing={3} pt={4}>
            <Skeleton isLoading>
              <Text size="sm" weight="medium">
                Description
              </Text>
            </Skeleton>
            <Skeleton.Text size="sm" lines={4} />
          </Stack>
        </Stack>
      </Stack>
    </Skeleton.Region>
  );
};
